import React from "react";
import Products from "./products";
import classNames from "classnames";
import { Pagination } from "react-bootstrap";
import BlockUi from "@availity/block-ui";

const  CustomPagination = ({ currentPage, totalPages, onPageClick }) => {
  const items = [];

  if (totalPages > 1) {
    items.push(<Pagination.First key="first" onClick={() => onPageClick(1)} disabled={currentPage === 1} />);
    items.push(<Pagination.Prev key="prev" onClick={() => onPageClick(currentPage - 1)} disabled={currentPage === 1} />);

    if (currentPage > 2) {
      items.push(<Pagination.Item key={1} onClick={() => onPageClick(1)}>{1}</Pagination.Item>);
      if (currentPage > 3) {
        items.push(<Pagination.Ellipsis key="ellipsis-start" onClick={() => onPageClick(currentPage - 2)}/>);
      }
    }

    const startPage = Math.max(1, currentPage - 1);
    const endPage = Math.min(totalPages, currentPage + 1);

    for (let i = startPage; i <= endPage; i++) {
      items.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => onPageClick(i)}>
          {i}
        </Pagination.Item>
      );
    }

    if (currentPage < totalPages - 1) {
      if (currentPage < totalPages - 2) {
        items.push(<Pagination.Ellipsis key="ellipsis-end" onClick={() => onPageClick(currentPage + 2)} />);
      }
      items.push(<Pagination.Item key={totalPages} onClick={() => onPageClick(totalPages)}>{totalPages}</Pagination.Item>);
    }

    items.push(<Pagination.Next key="next" onClick={() => onPageClick(currentPage + 1)} disabled={currentPage === totalPages} />);
    items.push(<Pagination.Last key="last" onClick={() => onPageClick(totalPages)} disabled={currentPage === totalPages} />);
  }

  return <Pagination>{items}</Pagination>;
}

const ProductsRoot = ({
  products,
  moreProductsCount,
  canLoadMore,
  viewMode,
  currentPage,
  productColumns,
  totalPages,
  productsPath,
  downloadPaths,
  availableDownloadOptions,
  onLoadMoreClick,
  selectedProductIds,
  blockingUI,
  showLinkToProductPageInProductMenu,
  translations,
  onProductPhotoClick,
  onDownloadClick,
  onPageClick
}) => {
  return (
    <BlockUi tag="div" blocking={blockingUI}>
      <div className="products__app">
        <div className="row">
          <div className="col-12 products__listing">
            <Products
              products={products}
              productColumns={productColumns}
              productsPath={productsPath}
              downloadPaths={downloadPaths}
              availableDownloadOptions={availableDownloadOptions}
              viewMode={viewMode}
              selectedProductIds={selectedProductIds}
              onProductPhotoClick={onProductPhotoClick}
              onDownloadClick={onDownloadClick}
              showLinkToProductPageInProductMenu={showLinkToProductPageInProductMenu}
              translations={translations}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-center">
              {totalPages > 0 && <CustomPagination 
                currentPage={currentPage}
                totalPages={totalPages}
                onPageClick={onPageClick}
              />}
            </div>
          </div>
        </div>
      </div>
    </BlockUi>
  );
}

export default ProductsRoot;